module.exports = __webpack_public_path__ + "static/media/tick-disabled.b56a4786.svg";